<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="[
        'Data da Criação',
        'Nome do Quadro',
        'Nome da Coluna',
        'Situação da Oportunidade'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn v-on:Edit="showLead(obj)" :IsDatetime="true" :status="1" :value="obj.dataCriacao" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.boardColumn.board.nome ? obj.boardColumn.board.nome : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.boardColumn.nome ? obj.boardColumn.nome : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.situacao ? obj.situacao.toUpperCase() === 'PERDIDO' ? 'PERDA' : obj.situacao : '-'" />
      </tr>
    </Tables>
    <!-- <ModalCard ref="ModalCard" v-if="selectedCard" @hideModal="hideLead" :key="selectedCard"
    @reloadBoardColumns="reloadBoardColumns" :boardColumns="boardColumns" :cardId="selectedCard" /> -->
    <ModalCard ref="ModalCard" v-if="selectedCard" @hideModal="hideLead" :key="selectedCard" :cardId="selectedCard" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import ModalCard from '../../crm/components/modalCard/modalCard.vue'

export default {
  name: 'CardsAssociate',
  mixins: [ActionsForm],
  data () {
    return {
      document: null,
      selectedCard: null
    }
  },
  components: {
    ModalCard
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadCardsAssociate(this.document)
      }
    },
    onLoadCardsAssociate (document) {
      loading.push()
      this.document = document
      CardRepository.SearchAllByDocument(document, '', this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    showLead (obj) {
      if (obj) {
        this.selectedCard = obj.id
      }
    },
    hideLead () {
      this.selectedCard = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/oportunidadesassociado.vue